export const START_LOADING = 'START_LOADING';
export const STOP_LOADING = 'STOP_LOADING';
export const SET_ERROR = 'SET_ERROR';
export const SUCCESS_LOGIN = 'SUCCESS_LOGIN';
export const SET_REGISTER_USER = 'SET_REGISTER_USER';

export const RESET_AUTH = 'RESET_AUTH';
